<template>
  <AutoCompleter ref="completer" :placeholder="placeholder" :results="results" :iid="iid" @reload="reload" @selected="selectValue">
    <template v-slot:listitem="data">
      {{ data.result.map_id }} - {{ data.result.customer.title }} - {{ data.result.created }}
    </template>
  </AutoCompleter>
</template>

<script>
import orders from '@/modules/orders.js'
import AutoCompleter from '@/components/AutoCompleter.vue'

export default {
  name: 'OrderAutoCompleter',
  props: ["iid","placeholder"],
  components: {
    AutoCompleter,
  },
  data() {
    return {
      results: [],
    }
  },
  created: function() {
    orders.viewparams.page = 1;
  },
  methods: {
    selectValue(data) {
      var link = { title: data.map_id + ' ' + data.customer.title + ' (' + data.customerid + ')' };
      this.$refs.completer.updateValue(data.id,link);
    },
    reload(search) {
      console.log(search);
      orders.viewparams.search = search;
      var self = this;
      orders.list(function(data) {
        self.results = data.rows;
      })
    }
  }
}
</script>
